module.exports = __webpack_public_path__ + "images/7ed30e8013bcc0407e73352ab5fe6cb0.jpg";